<template>
    <div class="categoryListWrap" v-if="categories !== undefined">
      <category
        v-for="(category) in categories"
        :key="category.num"
        :item="category"
        :all-active="isAllActive"
      />

    </div>
</template>

<script>
    import {mapGetters , mapState} from 'vuex'
    import Category from "./Category";
    import {bus} from '@/bus/event'

    export default {
        name: "category-list" ,
        components : {
          Category
        },
        computed : {
          ...mapState('categoryStore' , ['isAllActive']) ,
          ...mapGetters({
            categories : 'categoryStore/getCategories',
            categoryByAll : 'categoryStore/getCategoryByAll' ,
            activeCategory : 'categoryStore/getActiveCategory' ,
          })
        },
        updated () {
          //console.log('updated!!');
          //console.log('isAllAcitve', this.isAllActive);
          //console.log('isAllActive' , this.isAllACtive);
        },
        created () {
          //console.log(this.activeCategory);
          this.$store.dispatch('categoryStore/getCategories')
            .then( () => {

              /*this.$store.commit('categoryStore/setActiveCategory' , {
                activeCategory : this.categoryByAll
              })*/
            })
        },
        data () {
          return {

          }
        },
        method : {
        }

    }
</script>

<style scoped lang="scss">
  @import "@/styles/Portfolio.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio/CategoryList.vue